import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import type { Subscription } from '../types'

interface TrialBannerProps {
  subscription: Subscription
}

export function TrialBanner({ subscription }: TrialBannerProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const days = subscription.days_remaining_in_trial
  const isUrgent = days < 7

  return (
    <div
      role="status"
      className={[
        'flex items-center justify-between rounded-lg border px-4 py-3',
        isUrgent
          ? 'border-amber-300 bg-amber-50 text-amber-900'
          : 'border-blue-200 bg-blue-50 text-blue-900',
      ].join(' ')}
    >
      <p className="text-sm font-medium">
        {isUrgent
          ? t('subscription.trial_urgent', { count: days })
          : t('subscription.trial_remaining', { count: days })}
      </p>
      <button
        onClick={() => navigate('/subscription')}
        className={[
          'ml-4 min-h-[44px] rounded-md px-4 text-sm font-semibold transition-colors',
          isUrgent
            ? 'bg-amber-500 text-white hover:bg-amber-600'
            : 'bg-primary-500 text-white hover:bg-primary-600',
        ].join(' ')}
      >
        {t('subscription.banner_subscribe')}
      </button>
    </div>
  )
}
